<template>
  <div class="editGallery_box">
    <div class="topBar">
      <div class="subTitle">
        <i
          class="far fa-window-minimize"
          style="transform:rotate(90deg);margin-right: -10px;color:rgba(52,152,219,1);"
        ></i>
        编辑注册协议
        <div class="rutun">
          <div>
            <i class="fas fa-sync-alt"></i>
          </div>
          <div style="margin-left:4px" @click="flush()">刷新</div>
        </div>
      </div>
    </div>
    <div style="width: 1056px;margin: 0 auto">
      <div class="filtrate_head">
        <div class="filtrate_filer">编辑</div>
      </div>
      <div class="table">
        <el-form
          :label-position="labelPosition"
          label-width="100px"
          style="padding-top:30px; margin: 0 auto;width:100%"
        >
          <el-form-item label="标题:">
            <el-input v-model="title" style="width:300px"></el-input>
          </el-form-item>
          <el-form-item label="分类:">
            <template>
              <el-select v-model="value1" :data="options1" placeholder="分类">
                <el-option
                  v-for="item1 in options1"
                  :key="item1.value1"
                  :label="item1.class_name"
                  :value="item1.id"
                ></el-option>
              </el-select>
            </template>
          </el-form-item>
          <el-form-item label="上传图片:">
            <div class="grid-content">
              <input
                type="file"
                id="file"
                accept="image/png, image/jpeg, image/jpg"
                @change="getImage($event)"
              />
            </div>
          </el-form-item>

          <el-form-item label="编辑内容:">
            
            <div style="width:100%">
              <wanged-itor  :info="content" @change_edit="change_edit"></wanged-itor>
            </div>
          </el-form-item>

          <el-form-item>
            <el-button class="button" @click="submit()">提交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import WangedItor from "../components/wangeditor";
export default {
  components: {
    WangedItor
  },
  data() {
    return { serve: this.$store.state.serve,
      wang_edit: null,
      isture: true,
      options1: [],
      value1: "",
      radio: "1",
      labelPosition: "right",
      username: "",
      token: "",
      title: "",
      content: "",
      class_id: "",
      newImage: null,
      id: this.$route.params.id
    };
  },
  created() {
    //获取数据
    //获取下拉框
    this.$store.state.leftTitle = "文章编写";
    this.$store.state.topActiveId = 7;
    this.xiala();
    this.getting();
  },
  methods: {
    change_edit(data) {
      this.wang_edit = data;
    },
    handimg(file, Editor, cursorLocation, resetUploader) {
      let config = {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      };
      var formData = new FormData();
      formData.append("img", file);
      formData.append("username", this.username);
      formData.append("token", this.token);
      this.axios
        .post(
          this.serve+"/admin/edit_upload_img",
          formData,
          config
        )
        .then(res => {
          Editor.insertEmbed(cursorLocation, "image", res.data.data);
          resetUploader();
        });
    },
    xiala() {
      const that = this;
      this.username = this.$cookies.get("username");
      this.token = this.$cookies.get("token");
      if (this.token === this.token) {
        this.axios
          .get(this.serve+"/admin/text_class", {
            params: {
              username: this.username,
              token: this.token
            }
          })
          .then(res => {
            that.options1 = res.data.data;
          });
      }
    },
    getting() {
      const that = this;
      this.username = this.$cookies.get("username");
      this.token = this.$cookies.get("token");
      if (this.token === this.token) {
        this.axios
          .get(this.serve+"/admin/text_info", {
            params: {
              username: this.username,
              token: this.token,
              id: this.id
            }
          })
          .then(res => {
            var json = res.data.data;
            that.title = json.title;
            that.content = json.content;
            that.value1 = json.class;
          });
      }
    },
    getImage(e) {
      this.newImage = e.target.files[0];
    },
    submit() {
      const that = this;
      this.username = this.$cookies.get("username");
      this.token = this.$cookies.get("token");
      const loading = this.$loading({
        lock: true,
        text: "正在上传",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      let config = {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      };

      const formData = new FormData();
      formData.append("username", this.username);
      formData.append("token", this.token);
      formData.append("title", this.title);
      if (this.wang_edit === null) {
        formData.append("content", this.content);
      } else {
        formData.append("content", this.wang_edit);
      }
      formData.append("class_id", this.value1);
      formData.append("image", this.newImage);
      formData.append("id", this.id);
      this.axios
        .post(this.serve+"/admin/set_text", formData, config)
        .then(res => {
          if (res.data.status == "success") {
            that.$message({
              type: "success",
              message: "编辑成功"
            });
            loading.close();
            that.$router.push({ path: "/admin/g_adminProtocol" });
          }
        });
    }
  }
};
</script>
<style lang="scss">
.quillWrapper_box {
  padding: 0;
  margin: 0;
  width: 700px;
  .ql-toolbar {
    display: flex;
    align-items: center;

    justify-content: space-between;
    .ql-formats {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 !important;
      margin: 0 !important ;
      .ql-picker {
        .ql-picker-label {
          display: flex;
          align-items: center;
        }
      }
      .ql-header {
        .ql-picker-label {
          display: flex;
        }
      }
    }
  }
}

.editGallery_box {
  #tetx {
    width: 330px;
    height: 200px;
  }
  background: #f5f5f5;
  color: #333;
  min-height: 1000px;
  .filtrate_head {
    width: 100%;
    .filtrate_filer {
      height: 46px;
      width: 1040px;
      background: rgba(238, 238, 238, 1);
      border: 1px solid rgba(221, 221, 221, 1);
      font-size: 16px;
      font-family: "MicrosoftYaHei";
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      line-height: 46px;
      padding-left: 14px;
    }
    .filtrate_seek {
      position: relative;
      font-size: 16px;
      // border-bottom: 1px solid rgba(221, 221, 221, 1);
      border-left: 1px solid rgba(221, 221, 221, 1);
      border-right: 1px solid rgba(221, 221, 221, 1);
      border-bottom: 1px solid rgba(221, 221, 221, 1);
      height: 86px;
      font-family: "MicrosoftYaHeiLight";
      font-weight: 300;
      color: rgba(51, 51, 51, 1);
      // margin: 24px 0 0 17px;
      display: flex;
      align-items: center;
      background: #fff;
      > strong {
        font-size: 16px;
        font-family: "MicrosoftYaHei";
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        margin-left: 24px;
        margin-right: 6px;
      }
      .filtrate_seek_sousuo {
        text-align: center;
        line-height: 28px;
        font-size: 14px;
        font-family: "MicrosoftYaHeiLight";
        font-weight: 300;
        color: rgba(102, 102, 102, 1);
        width: 74px;
        height: 28px;
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(221, 221, 221, 1);
        position: absolute;
        right: 18px;
        top: 29px;
        cursor: pointer;
      }
      .filtrate_seek_sousuo:hover {
        color: #0099ff;
      }
    }
    .el-input__inner {
      // height: 28px;
    }
    .el-input__icon {
      line-height: 28px;
    }
  }
  .topBar {
    margin-bottom: 40px;
  }
  .subTitle {
    width: 1056px;
    margin: 0 auto;
    font-size: 14px;
    position: relative;
    .rutun {
      width: 78px;
      height: 28px;
      background: #fff;
      border: 1px solid rgba(221, 221, 221, 1);
      text-align: center;
      margin-top: 9px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      right: 0;
      top: 0;
      cursor: pointer;
    }
    .rutun:hover {
      color: #0099ff;
    }
  }

  textarea {
    height: 300px;
  }
  .form-title {
    background-color: #eee;
    border: 1px solid #ddd;
  }
  .table {
    background-color: #fff;
  }
  .row {
    margin-bottom: 20px;
  }
  .form {
    width: 450px;
    margin: 0 auto;
    padding: 20px 0;
    align-items: right;
  }
  .table {
    display: flex;
  }

  .label {
    line-height: 40px;
  }
  .button {
    width: 190px;
    height: 44px;
    background: rgba(0, 153, 255, 1);
    border-radius: 4px;
    margin-top: 30px;
    margin-bottom: 30px;
  }
  .button:hover {
    background: rgba(46, 172, 255, 1);
  }

  .notice {
    font-size: 13px;
    color: #666;
  }
}
</style>
